import {EventEmitter, EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {BeforeCreateGameEvent} from "@/modules/base/events/BeforeCreateGameEvent";
import SponsorFactory from "@/modules/sponsoring/services/SponsorFactory";
import {AfterSeasonEvaluationEvent} from "@/modules/season/events/AfterSeasonEvaluationEvent";
import {Team} from "@/modules/team/entity";
import {Sponsor} from "@/modules/sponsoring/entity";
import {SponsorTypeEnum} from "@/modules/sponsoring/enums";
import {BeforeSponsoringOffersCreationEvent} from "@/modules/sponsoring/events/BeforeSponsoringOffersCreationEvent";
import {AfterSponsoringOffersCreationEvent} from "@/modules/sponsoring/events/AfterSponsoringOffersCreationEvent";

@injectable()
export class GameCreationEventSubscriber implements EventSubscriber {
  constructor(
    @inject(SponsorFactory) private sponsorFactory: SponsorFactory,
    @inject(EventEmitter) private em: EventEmitter,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: BeforeCreateGameEvent, callback: this.onBeforeCreateGame},
      {event: AfterSeasonEvaluationEvent, callback: this.onAfterSeasonEvaluationEvent},
    ];
  }

  async onBeforeCreateGame(event: BeforeCreateGameEvent): Promise<void> {
    await Object.values(SponsorTypeEnum)
      .forEachAsync((type: SponsorTypeEnum) => this.sponsorFactory.generate(100, type));
  }

  async onAfterSeasonEvaluationEvent(event: AfterSeasonEvaluationEvent): Promise<void> {
    await this.em.emitAsync(new BeforeSponsoringOffersCreationEvent());

    const team = await Team.current();

    await (await Sponsor.find()).forEachAsync((s: Sponsor) => s.remove());

    const sponsors = await Object.values(SponsorTypeEnum)
      .mapAsync((type: SponsorTypeEnum) => this.sponsorFactory.generate(team.prestige, type));

    await this.em.emitAsync(new AfterSponsoringOffersCreationEvent(sponsors));
  }
}